<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Poser une question</p>
    </header>
    <template v-if="confirmNoDocument || this.document">

      <section class="modal-card-body">

        <b-field label="Thème :" :type="errors.theme ? 'is-danger' : null" :message="errors.theme">
          <b-select v-model="theme" placeholder="Sélectionnez un thème">
            <option v-for="theme in questionThemes" :value="theme.id" :key="theme.id"> {{ theme.name }} </option>
          </b-select>
        </b-field>
        <b-field label="Objet :" :type="errors.sujet ? 'is-danger' : null" :message="errors.sujet">
          <b-input v-model="sujet" />
        </b-field>
        <b-field label="Votre question :" :type="errors.question ? 'is-danger' : null" :message="errors.question">
          <b-input v-model="question" type="textarea" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button :class="{ 'is-loading': loading }" class="button is-primary" @click="send"> Envoyer </button>
        <button class="button" type="button" @click="$parent.close()"> Annuler </button>
      </footer>

    </template>
    <template v-else>

      <section class="modal-card-body no-document">

        <b-message type="is-warning" has-icon>
          <strong>Attention!</strong><br>
          Cette question ne sera liée à aucun document.
        </b-message>

        <p><strong>Pour poser une question relative à un document :</strong></p>

        <div class="columns">
          <div class="column">
            <ul>
              <li>Aller dans l'onglet "Documents"</li>
              <li>Dérouler l'Arborescence Notariale</li>
              <li>Cliquer sur un document, <br>puis choisir "Poser une question"</li>
            </ul>
          </div>
          <div class="column is-one-third">
            <img src="../../assets/images/question-screenshot.png" />
          </div>
        </div>

        <p>
          Voulez-vous poser une question sur l'actif, sans rapport avec l'un des documents ?
        </p>

      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="confirmNoDocument = true">
          Oui
        </button>
        <button class="button" type="button" @click="$parent.close()">
          Non
        </button>
      </footer>

    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import MixinStringHelper from '@/mixins/StringHelper'

export default {
  mixins: [MixinStringHelper],
  props: {
    document: {
      type: Number,
      default: () => null,
    },
    an: {
      type: Number,
      default: () => null,
    },
    anLevel: {
      type: Number,
      default: () => null,
    },
  },
  data () {
    return {
      sujet: '',
      question: '',
      theme: null,
      loading: false,
      confirmNoDocument: false,
      errors: {},
    }
  },
  computed: {
    ...mapState({
      arboNot: state => state.inv.arboNot,
      questionThemes: state => state.inv.questionThemes,
    }),
    fullArboNot () {
      if (!this.an) return []

      let an = _.find(this.arboNot, { id: this.an })
      let arboNot = [an]
      while (an && an.parent && an.level > 0) {
        an = _.find(this.arboNot, { id: an.parent })
        arboNot.unshift(an)
      }
      return arboNot
    },
  },
  async created () {
    await this.$store.dispatch('inv/getQuestionThemes')
    this.getThemeFromArboNot()
  },
  methods: {
    getThemeFromArboNot () {
      if (this.fullArboNot.length === 0) return
      let an0Name = this.fullArboNot[0].name.replace(/^([^\s]+\s)/, '')

      // normalizeString defined in mixins/StringHelper.js
      // Assing to temporary variable as 'this' isn't available in anonymous functions.
      let tempNormalize = this.normalizeString
      const theme = _.find(this.questionThemes, function (t) {
        return tempNormalize(t.name.toLowerCase()) === tempNormalize(an0Name.toLowerCase())
      })
      if (theme) {
        this.theme = theme.id
      }
    },
    validate () {
      this.errors = {}
      if (this.sujet.length === 0) {
        this.$set(this.errors, 'sujet', 'Ce champ est obligatoire')
      }
      if (this.question.length === 0) {
        this.$set(this.errors, 'question', 'Ce champ est obligatoire')
      }
      if (!this.theme) {
        this.$set(this.errors, 'theme', 'Ce champ est obligatoire')
      }
      return Object.keys(this.errors).length === 0
    },
    async send () {
      if (!this.validate()) return
      this.loading = true

      try {
        const formData = {
          sujet: this.sujet,
          question: this.question,
          theme: this.theme,
          bien: +this.$route.params.bien || null,
          portefeuille: +this.$route.params.portefeuille || null,
        }
        console.log(this.sujet + '-' + this.question + '-' + this.theme + '-' + this.$route.params.bien + '-' + this.$route.params.portefeuille + '-' + this.document)
        if (this.fullArboNot) {
          formData.an = this.fullArboNot.map(i => ({
            id: i.id,
            level: i.level,
          }))
        }
        if (this.document) {
          formData.document = this.document
        }
        await this.$api.post(`/inv/questions`, formData)
        this.$emit('sent')
        this.$parent.close()

        this.sujet = ''
        this.question = ''

        this.$toast.open('Votre question a été envoyée.')
      } catch (e) {
        this.apiError(e)
      }
      this.loading = false
    }
  },
}
</script>

<style lang="scss" scoped>
.no-document {
  p {
    margin-bottom: 1em;
  }

  p:last-child {
    margin-top: 1em;
    margin-bottom: 0;
    font-style: italic;
  }
}

ul {
  li {
    padding-top: .6em;
    list-style: square;
    margin-left: 2em;
  }
}

img {
  border: 8px solid #f6f6f6;
}
</style>
